/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LinkAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Copy from 'DesignSystem/Copy/index'
import QrCode from 'DesignSystem/QrCode/react'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LinkAction({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Footer/SendForSignatureAction/Content/Content/LinkAction"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let signatureIdValueData = fromData.useDataValue({ viewPath,
context: 'signature',
path: 'id',
})
let aggregateData = fromHelpers.getSignatureRequestUrl(signatureIdValueData)
let signatureIdValueData1 = fromData.useDataValue({ viewPath,
context: 'signature',
path: 'id',
})
let aggregateData1 = fromHelpers.getSignatureRequestUrl(signatureIdValueData1)
let signatureIdValueData2 = fromData.useDataValue({ viewPath,
context: 'signature',
path: 'id',
})
let aggregateData2 = fromHelpers.getSignatureRequestUrl(signatureIdValueData2)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="LinkAction.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z2lECbk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 text="Signature request link"
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 marginLeft={0}
 data="signature.id"
 aggregate="helpers.js getSignatureRequestUrl"
 value={aggregateData}
 text="Copy signature request link"
/>
</div>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 data="signature.id"
 aggregate="helpers.js getSignatureRequestUrl"
 goTo={aggregateData1}
 text={aggregateData1}
/>
<QrCode
  viewPath={`${viewPath}/QrCode`}
 marginLeft="auto"
 marginRight="auto"
 marginTop={dtSpaceM}
 size={360}
 data="signature.id"
 aggregate="helpers.js getSignatureRequestUrl"
 value={aggregateData2}
/>
{children}
</React.Fragment>)
}